import { motion } from "framer-motion";
import { useLang } from "@/i18n/LangContext";

const ABOUT_BG =
    "https://static.prod-images.emergentagent.com/jobs/359e1a58-6c2d-46ea-8fb3-26c1f78309e7/images/47d3df6eb1cb33ae59c448bd34272924ba83e4f2e18ea763aee37d2df6c7372f.png";

const DEFAULT_TEXT =
    "Project Ruda Śląska to fanowska modyfikacja do gry Euro Truck Simulator 2, która dodaje tereny miasta Rudy Śląskiej w skali 1:1. Modyfikacja jest tworzona głównie przez jedną osobę, a jej początki sięgają lipca 2024.";

export default function About({ modInfo }) {
    const { t, lang } = useLang();
    const text = modInfo?.about_text || DEFAULT_TEXT;

    return (
        <section
            id="o-projekcie"
            data-testid="about-section"
            className="relative py-24 md:py-32 overflow-hidden"
        >
            <div className="absolute inset-0 opacity-[0.07]">
                <div
                    className="absolute inset-0 bg-cover bg-center"
                    style={{ backgroundImage: `url(${ABOUT_BG})` }}
                />
            </div>
            <div className="absolute inset-0 bg-gradient-to-b from-[color:var(--bg-base)] via-[color:var(--bg-base)]/95 to-[color:var(--bg-base)]" />

            <div className="relative max-w-7xl mx-auto px-6 md:px-12">
                <div className="grid md:grid-cols-12 gap-8 lg:gap-16 items-start">
                    <div className="md:col-span-5">
                        <div className="label-eyebrow mb-4">{t("01 - O projekcie")}</div>
                        <h2 className="font-display uppercase text-4xl md:text-5xl lg:text-6xl tracking-tighter text-white leading-[0.95]">
                            {lang === "en" ? (
                                t("Śląsk w kabinie Twojej ciężarówki")
                            ) : (
                                <>Śląsk<br />w kabinie<br />Twojej<br />ciężarówki</>
                            )}
                        </h2>
                    </div>
                    <motion.div
                        initial={{ opacity: 0, y: 16 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.3 }}
                        transition={{ duration: 0.6 }}
                        className="md:col-span-7 md:pt-4"
                    >
                        <div className="relative pl-8 border-l-2 border-[color:var(--primary)]/40">
                            <div className="absolute top-0 left-[-5px] w-2 h-2 rounded-full bg-[color:var(--primary)]" />
                            {text.split(/\n+/).map((para, i) => (
                                <p
                                    key={i}
                                    className="text-lg md:text-xl text-[color:var(--text-secondary)] leading-relaxed mb-5 last:mb-0"
                                    data-testid={`about-paragraph-${i}`}
                                >
                                    {t(para)}
                                </p>
                            ))}
                            <div className="mt-8 inline-flex items-center gap-3 text-xs uppercase tracking-[0.3em] text-[color:var(--primary)]">
                                <span className="h-px w-8 bg-[color:var(--primary)]" />
                                {t("Od lipca 2024")}
                            </div>
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
}
